import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>New Passes</Typography>
      <p>
        This is where you will issue test passes to try out your templates during the design phase.
        it is important that you review your passes on real devices. Our previews are very accurate,
        but not completely perfect (Apple in particular does some odd formatting that we cannot 
        replicate entierly in a browser).
      </p>

      <Typography variant='h5' className='pt-10 pb-5'>Live passes</Typography>
      <p>You can also issue live passes here by uploading a data file with the specific details of the passes.
        Alternatively, you can integrate Smartix API into your workflow and automate issing and managing
        passes from within your own infastruture.
      </p>

      <Typography variant='h5' className='pt-10 pb-5'>Pass data</Typography>
      <p>If you are issuing a test pass you can either uplaod a data file, or just use the same data associated with your template.
        If you are issuing live passes then you ust upload a data file.
      </p>

      <p>You can upload data in JSON, CSV or MS Excel format. To ensure that your data format is correct, please use the download
        button to get a copy of the sample data which you can use as a guide.
      </p>

      <Typography variant='h5' className='pt-10 pb-5'>Follow the steps...</Typography>
      <p>We have a simple step-by-step process to issue passes. Just review the options at each step before proceeding.
        You be guided through the process. When passe shave been issued, you'll see a table which list all the passes that have 
        been issued. If there where any problems, then the table ntries will show them. 
      </p>

      <Typography variant='h5' className='pt-10 pb-5'>Managed Templates</Typography>
      <p> If you are using one of our Smartix Manage Templates, then your options here will be more limited and will
        depend upon the type of template you are using.
      </p>

      <Typography variant='h6' className='pt-10 pb-5 pl-5'>Giftcards</Typography>
      <p className='pl-10'>You can create a test giftcard (with a £25 value) with a single click. Live giftcards can be created 
        but choosing an anount and expiry date.</p>

      <Typography variant='h6' className='pt-10 pb-5 pl-5'>Stampcards</Typography>
      <p className='pl-10'>You can create a test stampcard. Live stampcard can only be cerated by visiting your live signup page.
        You'll see a link, or you can scan the barcode with a mobile device.
      </p>

      <Typography variant='h6' className='pt-10 pb-5 pl-5'>Event tickets</Typography>
      <p className='pl-10'>You'll need to provide a data file for live event ticket just like for non-managed templates.</p>
    </div>
  )
}

export default HelpText